module.exports = __webpack_public_path__ + "assets/images/albom3.d68cbc69.jpg";